export default {
  computed: {
    mecCertificationsRoutes() {
      return {
        "mec-certifications-unifast": {
          title: "Unifast"
        }
      }
    }
  }
}